(() => {
  // The cart drawer's contents get replaced wholesale on every cart update
  // (renderContents swaps innerHTML), which would silently drop any
  // listeners attached directly to its elements - delegating from document
  // means this keeps working after every re-render without re-binding.

  function applyGateState() {
    const checkbox = document.getElementById('CartDrawer-Consent');
    const gate = document.querySelector('[data-cart-consent-gate]');
    if (!checkbox || !gate) return;

    const agreed = checkbox.checked;
    const checkoutButton = document.getElementById('CartDrawer-Checkout');

    if (checkoutButton) {
      // An empty cart disables this regardless of consent - only let consent
      // re-enable it when that's not also in play.
      if (checkoutButton.dataset.emptyCartDisabled !== 'true') {
        checkoutButton.disabled = !agreed;
      }
    }

    // The Scala Discounts app's checkout button is a web component, not a
    // native form control - can't set .disabled on it, so block it the same
    // way its own hide-our-button CSS does: visually and with pointer-events.
    const scalaButton = document.querySelector('scala-cart-button');
    if (scalaButton) {
      scalaButton.classList.toggle('cart-consent-gate--locked', !agreed);
    }
  }

  function closeAllPolicyModals() {
    document.querySelectorAll('[data-policy-modal]:not([hidden])').forEach((modal) => {
      modal.hidden = true;
    });
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeAllPolicyModals();
  }

  document.addEventListener('change', (event) => {
    if (event.target.id === 'CartDrawer-Consent') applyGateState();
  });

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-policy-modal-open]');
    if (openTrigger) {
      const modal = document.getElementById(openTrigger.dataset.policyModalOpen);
      if (modal) modal.hidden = false;
      return;
    }

    // Clicking the surrounding sentence (but not the Terms/Refund links
    // themselves, already handled above) toggles the checkbox - the links
    // can't live inside a <label> (buttons aren't labelable, see the
    // earlier fix), so this reproduces the same "click the text to toggle"
    // behavior manually instead.
    const text = event.target.closest('.cart-consent__text');
    if (text) {
      const checkbox = document.getElementById('CartDrawer-Consent');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('keydown', onKeydown);

  // Policy modals render once at the global layout level (not inside the
  // cart drawer's AJAX-replaced content), so direct listeners here are safe
  // - same proven click-the-backdrop-to-close pattern as the popup banner:
  // the modal itself closes on any click, and the dialog stops that click
  // from bubbling so clicking the policy text/close button doesn't also
  // trigger it via the backdrop.
  document.querySelectorAll('[data-policy-modal]').forEach((modal) => {
    modal.addEventListener('click', () => {
      modal.hidden = true;
    });
  });

  document.querySelectorAll('[data-policy-modal-stop]').forEach((el) => {
    el.addEventListener('click', (event) => event.stopPropagation());
  });

  document.querySelectorAll('[data-policy-modal-close]').forEach((el) => {
    el.addEventListener('click', () => {
      const modal = el.closest('[data-policy-modal]');
      if (modal) modal.hidden = true;
    });
  });

  const drawerRoot = document.querySelector('cart-drawer');
  if (drawerRoot) {
    new MutationObserver(applyGateState).observe(drawerRoot, { childList: true, subtree: true });
  }

  applyGateState();
})();
